module.exports = __webpack_public_path__ + "img/background-kitchen-pc.8e9be1de.jpg";